<template>
  <RevCard class="p-24 lg:p-32">
    <div class="flex flex-col items-start justify-between lg:flex-row">
      <div class="mb-24 flex items-center justify-between lg:mb-0">
        <IconSwap />
        <div class="ml-24">
          <span class="body-1-bold">
            {{
              i18n(translations.buybackSwapSummaryPriceNew, {
                price: i18n.price(props.price),
              })
            }}
          </span>
          <p class="body-2 mt-8">
            {{ props.title }}
          </p>
        </div>
      </div>
      <RevButtonTiny
        data-qa="swap-summary-delete"
        data-test="swap-summary-delete"
        variant="secondary"
        @click="handleDelete"
      >
        {{ i18n(translations.buybackSwapSummaryDelete) }}
      </RevButtonTiny>
    </div>
    <div class="mt-56">
      <span class="body-1">
        {{ i18n(translations.buybackSwapSummaryTitle) }}
      </span>
      <RevList class="mt-14">
        <RevListItemStatic v-for="detail in props.details" :key="detail.label">
          <template #label>
            <span class="body-2">
              {{ detail.label }}
            </span>
          </template>
          <template #suffix>
            <span class="body-2">
              {{ detail.value }}
            </span>
          </template>
        </RevListItemStatic>
      </RevList>
    </div>
  </RevCard>
</template>

<script lang="ts" setup>
import type { Price } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonTiny } from '@ds/components/ButtonTiny'
import { RevCard } from '@ds/components/Card'
import { RevList } from '@ds/components/List'
import { RevListItemStatic } from '@ds/components/ListItemStatic'
import { IconSwap } from '@ds/icons/IconSwap'

import translations from './SwapSummary.translations'

const i18n = useI18n()

interface SummaryDetails {
  label: string
  value: string
}

export interface SwapSummaryProps {
  title: string
  price: Price
  details: Array<SummaryDetails>
}

const props = withDefaults(defineProps<SwapSummaryProps>(), {
  details: () => [],
})

const emit = defineEmits<{
  (event: 'delete-swap'): void
}>()

function handleDelete() {
  emit('delete-swap')
}
</script>
